import { SourcingPreferencesFieldProps } from "./interfaces";

import { Icon } from "@otta/icons";
import { VerticalSpacing, Label, Text } from "@otta/design";
import { MultiTextInput } from "@hire/components/input/MultiTextInput";
import { TooltipWithIcon } from "@hire/components/TooltipWithIcon";

export function KeywordsField({
  preferences,
  onChange,
}: SourcingPreferencesFieldProps): React.ReactElement {
  return (
    <VerticalSpacing size={-4}>
      <TooltipWithIcon
        content="Search single words, multiple words, or multi-word phrases (e.g. “product design”)"
        icon={<Icon icon="circle-info" size={1} />}
      >
        <Label htmlFor="keywords">
          <Text bold>Keyword search</Text>
        </Label>
      </TooltipWithIcon>
      <MultiTextInput
        value={preferences.keywords ?? []}
        placeholder="Enter keywords"
        minLength={1}
        onChange={vals => {
          onChange({ keywords: vals });
        }}
      />
    </VerticalSpacing>
  );
}
